import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import { useTheme } from '../context/ThemeProvider'
import { useThemeAssets } from '../hooks/useThemeAssets'
import { getThemeMode } from '../utils/theme-utils'
import { ThemeMode } from '../constants/theme'

const NotFoundPage = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { theme } = useTheme()
  const { svgAssets } = useThemeAssets()

  const isDarkMode = getThemeMode(theme) === ThemeMode.DARK
  const error404Image = isDarkMode
    ? svgAssets.ERROR_404.dark
    : svgAssets.ERROR_404.light

  const handleBackToHome = () => {
    navigate('/')
  }

  return (
    <div className="min-h-screen bg-[var(--bg-theme)] flex flex-col items-center justify-center px-4 py-8">
      <div className="max-w-md w-full text-center">
        {/* 404 SVG Icon using imported assets */}
        <div className="mb-4">
          <img
            src={error404Image}
            alt={t('page404.title')}
            className="w-full h-auto max-w-sm mx-auto"
          />
        </div>

        {/* Error Message */}
        <div className="mb-8">
          <h1 className="text-3xl md:text-4xl font-bold text-[var(--card-title)] mb-4">
            {t('page404.header')}
          </h1>
          <p className="text-lg text-[var(--card-subtext)] mb-6">
            {t('page404.description')}
          </p>
        </div>

        {/* Back to Home Button */}
        <button
          onClick={handleBackToHome}
          className="w-full md:w-auto px-8 py-3 font-semibold rounded-lg active-gradient"
        >
          {t('page404.backToHome')}
        </button>
      </div>
    </div>
  )
}

export default NotFoundPage
